/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import { Toolbar, Button, withStyles } from '@material-ui/core'

// custom components
import Link from '../Links/Link'
import useArticleTags from '../../data/useTagsByArticles'

// Utils
const kebabCase = require('lodash/kebabCase')

const styles = theme => ({
  toolbar: {
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      flexDirection: 'row'
    }
  },
  button: {
    marginBottom: theme.spacing(1),
    flexShrink: 0,
    alignSelf: 'stretch',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: 0,
      marginTop: 0,
      alignSelf: 'center'
    }
  }
})

/**
 * Render a toolbar containing links to tag pages for all tags in article pages
 * @param classes
 * @return {JSX.Element}
 * @constructor
 */
function ArticlesTagsToolbar({ classes }) {
  const tags = useArticleTags()

  return (
    <Toolbar component="nav" variant="dense" className={classes.toolbar}>
      {tags.map(tag => {
        const to = tag === 'All' ? '/articles/' : `/articles/tags/${kebabCase(tag)}/`

        return (
          <Button
            className={classes.button}
            key={tag}
            component={Link}
            to={to}
            variant="outlined"
            size="small"
            color="secondary"
          >
            {tag}
          </Button>
        )
      })}
    </Toolbar>
  )
}

export default withStyles(styles)(ArticlesTagsToolbar)
